export default __webpack_public_path__ + "static/media/Gallery - Edition II vs IV - 2_03.cb2a5919.jpg";